// import axios from "axios";
import secure_axios from "../../services/secure_axios";

const initialState =()=>({
  allsalesorders: [],
  salesorderitems:[],
  selectedorder:[],
});

const state = initialState();
const getters = {
  allsalesorders: (state) => state.allsalesorders,
  salesorderitems: (state) => state.salesorderitems,
  selectedorder: (state) => state.selectedorder
};

const mutations = {
  setallsalesorders(state, payload) {
    state.allsalesorders = payload;
  },
  setsalesorderitems(state, payload) {
    state.salesorderitems = payload;
  },
  setselectedorder(state,payload) {
    state.selectedorder = payload
  },
  clearorderitems(state) {
    state.salesorderitems = [];
  },  
  RESET_STATE(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  }, 
};

const actions = {
    getallsalesorders({ commit,getters }, payload) {      
      commit("setLoading", true); 
      commit("clearError");
  
      const smandocno = payload.smandocno;
      const sodoctype = payload.sodoctype;
      secure_axios
        .get(`${getters.sessionAPI}orders?smandocno=${smandocno}&sodoctype=${sodoctype}`)
        .then((response) => {          
          commit("setallsalesorders", response.data.salesorder);
          commit("setLoading", false);
        })
        .catch((error) => {
          commit("setLoading", false);
          commit("setError", error);
        });
    },
    getsalesorderitems({ commit,getters }, payload) {      
      commit("setLoading", true); 
      commit("clearError");
  
      const saldet_docno = payload.saldet_docno;      
      secure_axios
        .get(`${getters.sessionAPI}orderitems?saldet_docno=${saldet_docno}`)
        .then((response) => {          
          commit("setsalesorderitems", response.data.salesorderitems);
          commit("setLoading", false);
        })
        .catch((error) => {
          commit("setLoading", false);
          commit("setError", error);
        });
    },
    clearorderitems({ commit }) {
      commit("clearorderitems");
    },
  
    selectedorder({ commit }, payload) {
      commit("setselectedorder", payload);
    }, 
};

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
};
